export enum NotyMessagesEnum {
    equipmentCardUpdatedMessage = 'Оборудование сохранено',
    specialistUpdatedMessage = 'Специалист сохранен',

    technicalDeviceUpdateMessage = 'Техническое устройство сохранено',
    technicalDeviceRemovedMessage = 'Техническое устройство удалено',
    technicalDeviceRemovedFailMessage = 'Не удалось удалить техническое устройство',
    technicalDeviceDocumentationUpdateMessage = 'Документ сохранен',
    technicalDeviceDocumentationRemovedMessage = 'Документ удален',
    technicalDeviceDocumentationRemovedFailMessage = 'Не удалось удалить документ',
    technicalDeviceElementUpdatedMessage = 'Элемент контроля сохранен',
    technicalDeviceElementRemovedMessage = 'Элемент контроля удален',
    technicalDeviceElementRemovedFailMessage = 'Не удалось удалить элемент контроля',
    technicalDeviceElementGroupUpdatedMessage = 'Типоразмер сохранен',
    technicalDeviceElementGroupRemovedMessage = 'Типоразмер удален',
    technicalDeviceElementGroupRemovedFailMessage = 'Не удалось удалить типоразмер',
    technicalDeviceTechnicalCardUpdatedMessage = 'Техкарта сохранена',
    technicalDeviceTechnicalCardRemovedMessage = 'Техкарта удалена',
    technicalDeviceTechnicalCardRemovedFailMessage = 'Не удалось удалить техкарту',

    conclusionUpdatedMessage = 'Заключение сохранено',
    conclusionRemovedMessage = 'Заключение удалено',
    conclusionRemovedFailMessage = 'Не удалось удалить заключение',
    conclusionScanUpdatedMessage = 'Скан заключения сохранен',
    conclusionScanRemovedMessage = 'Скан удален',
    conclusionScanRemovedFailMessage = 'Не удалось удалить скан заключения',

    workingObjectUpdatedMessage = 'Объект сохранен',
    workingObjectRemovedMessage = 'Объект удален',
    workingObjectListRemovedMessage = 'Объекты удалены',
    workingObjectListRemovedFailMessage = 'Не удалось удалить объекты',
    workingObjectRemovedFailMessage = 'Не удалось удалить объект',
    workingObjectSpecialistUpdatedMessage = 'Специалист добавлен к объекту',
    workingObjectSpecialistUpdatedFailMessage = 'Не удалось добавить специалиcта к объекту',
    workingObjectSpecialistDuplicateMessage = 'Специалист уже был добавлен ранее',
    workingObjectSpecialistRemovedMessage = 'Специалист удален с объекта',
    workingObjectSpecialistRemovedFailMessage = 'Не удалось удалить специалиcта с объекта',
    workingObjectEquipmentListUpdatedMessage = 'Состав оборудования на объекте изменен',
    workingObjectEquipmentListUpdatedFailMessage = 'Не удалось изменить состав оборудования на объекте',
    workingObjectEquipmentListRemoveMessage = 'Оборудование удалено с объекта',
    workingObjectEquipmentListRemoveFailMessage = 'Не удалось удалить оборудование с объекта',

    laboratoryDocumentUpdated = 'Документ сохранен',
    laboratoryDocumentRemoved = 'Документ удален',
    laboratoryDocumentRemovedFail = 'Не удалось удалить документ',
}
